import {
  LetterbookType,
  LetterlistTableColumnSettingType,
} from "features/Letterbooks/types";
import pluralize from "lib/pluralize";
import LetterbookCell from "../LetterbookCell";

export default function UsersCountColumn({
  letterbook,
}: {
  letterbook: LetterbookType;
}) {
  const { book } = letterbook;
  return (
    <LetterbookCell className="font-bold text-lg">
      <>
        {book.usersCount.toLocaleString()} {pluralize("save", book.usersCount)}
      </>
    </LetterbookCell>
  );
}

export const settings = {
  key: "UsersCount",
  title: "Reader Saves",
} as LetterlistTableColumnSettingType;
